import script from "./football.vue?vue&type=script&setup=true&name=FootballMatch&lang=js"
export * from "./football.vue?vue&type=script&setup=true&name=FootballMatch&lang=js"

import "./football.vue?vue&type=style&index=0&id=205751b5&scoped=true&lang=css"
import "./football.vue?vue&type=style&index=1&id=205751b5&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-205751b5"]])

export default __exports__